<template>
    <div>
        <b-row class="pb-2">
            <b-col>
                <app-detalhe titulo="Centro de Custo" :xl="xl">
                    <strong>{{ item.nomeCCusto }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Natureza Orçamentária" :xl="xl">
                    <strong>{{ item.codOrcamento }} - {{ item.descOrcamento }}</strong>
                    <btn-editar-orcamento-item
                        :item="item"
                        :contrato="contrato"
                        @atualizado="onOrcamentoAtualizado"
                    ></btn-editar-orcamento-item>
                </app-detalhe>
                <!-- <app-detalhe titulo="Departamentos" :xl="xl">
                    <strong>{{ item.nomeDepartamento }}</strong>
                </app-detalhe> -->
                <!-- <app-detalhe titulo="Despesa / Receita" :xl="xl">
                    <strong>{{ item.descDespesaReceita }}</strong>
                </app-detalhe> -->
                <!-- <app-detalhe titulo="Vendedor 1" :xl="xl">
                    <strong>{{ item.nomeVendedor1 }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Vendedor 2" :xl="xl">
                    <strong>{{ item.nomeVendedor2 }}</strong>
                </app-detalhe> -->
            </b-col>
        </b-row>
  </div>
</template>

<script>
import BtnEditarOrcamentoItem from '../BtnEditarOrcamentoItem.vue'

export default {
    components: {
        BtnEditarOrcamentoItem
    },

    props: {
        item: {
            type: Object,
            default: () => {}
        },
        contrato: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            xl: 2,
        }
    },

    methods: {
        onOrcamentoAtualizado(orcamento) {
            this.item.codOrcamento = orcamento.codOrcamento
            this.item.descOrcamento = orcamento.descOrcamento
        }
    },

    created() {
    },
}

</script>

<style>

</style>